import React, { useState, useEffect } from "react";
import { InputLabel } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "../styles/pages/TemplateManager.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import CheckIcon from "@mui/icons-material/Check";
//import { Tooltip } from "bootstrap";
import Tooltip from "@mui/material/Tooltip";
const iconComponent = (props) => {
  return <ExpandMoreIcon className={props.className} />;
};

const DropdownWithLabelTemplate = (props) => {
  const [options, setOptions] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const labelId = `${options?.name || "template-dropdown"}-label`;

  useEffect(() => {
    setOptions(props.options || {});
  }, [props.options]);

  const handleLabelClick = () => {
    if (!options.disabled) {
      setIsOpen(true);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSelectOpen = () => {
    setIsOpen(true);
    if (options.onOpen) {
      options.onOpen();
    }
  };

  const handleDisable = (optionName) => {
    // const disabled = (props.tick?.length >0 && props.tick?.some( animation=> animation !== undefined && animation.animationType === options.value  ) && !animationCombination[options.value]?.includes(item) )? true: false;
    // setDisabled(prevState=>{ prevState === true ? true :disabled});
  };

  const getValue = () => {
    if (
      options &&
      options.items &&
      options.items.length > 0 &&
      options.value &&
      options.items.indexOf(options.value) !== -1
    ) {
      return options.value;
    }
    return "";
  };

  return (
    <FormControl
      // className="drop-down-with-label"
      className="tempInputField "
      variant="standard"
      fullWidth={true}
    >
      <InputLabel
        htmlFor={options.name}
        id={labelId}
        onClick={handleLabelClick}
        style={{ cursor: "pointer" }}
      >
        {options.label}
      </InputLabel>
      {options.name === "campaign" ? (
        <Tooltip
          title={options?.value?.length >= 10 ? getValue() : ""}
          placement="top"
        >
          <Select
            labelId={labelId}
            //id="demo-simple-select-standard"
            value={getValue()}
            open={isOpen}
            onClose={handleClose}
            onOpen={handleSelectOpen}
            //openText="Open232"
            onChange={options.handleChange}
            disabled={options.disabled}
            label={options.label}
            name={options.name}
            id={options.name}
            MenuProps={{
              variant: "menu",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              PaperProps: {
                style: {
                  maxWidth: props.menuWidth,
                  marginTop: 4,
                },
              },
              getContentAnchorEl: null,
              disableAutoFocusItem: true,
            }}
            IconComponent={iconComponent}
          >
            {options.items &&
              options.items.length > 0 &&
              options.items.map((item, index) => {
                {
                  /* const disabled = (props.tick?.length >0 && props.tick?.some( animation=> animation !== undefined && animation.animationType === options.value  ) && !animationCombination[options.value]?.includes(item) )? true: false; */
                }
                return (
                  <MenuItem value={item} id={item} key={item}>
                    {/*   <div className="menuItemAnimation"> */}
                    {item}{" "}
                    {props.tick?.some(
                      (animation) =>
                        animation !== undefined &&
                        animation.animationType === item
                    ) ? (
                      <CheckIcon style={{ color: "#00b10a", fontSize: 15 }} />
                    ) : (
                      ""
                    )}
                    {/*   </div> */}
                  </MenuItem>
                );
              })}
          </Select>
        </Tooltip>
      ) : (
        <Select
          labelId={labelId}
          //id="demo-simple-select-standard"
          value={getValue()}
          open={isOpen}
          onClose={handleClose}
          onOpen={handleSelectOpen}
          onChange={options.handleChange}
          disabled={options.disabled}
          label={options.label}
          name={options.name}
          id={options.name}
          MenuProps={{
            variant: "menu",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            PaperProps: {
              style: {
                maxWidth: props.menuWidth,
                marginTop: 4,
              },
            },
            getContentAnchorEl: null,
            disableAutoFocusItem: true,
          }}
          IconComponent={iconComponent}
        >
          {options.items &&
            options.items.length > 0 &&
            options.items.map((item, index) => {
              {
                /* const disabled = (props.tick?.length >0 && props.tick?.some( animation=> animation !== undefined && animation.animationType === options.value  ) && !animationCombination[options.value]?.includes(item) )? true: false; */
              }
              return (
                <MenuItem
                  value={item}
                  id={item}
                  key={item}
                  // className={
                  //   item === "— Not Brand Specific —" ? "notbranded" : ""
                  // }
                  className={`menu-items ${item === props.options.value ? "blue-background" : "no-blue-background"}`}
                >
                  {/*   <div className="menuItemAnimation"> */}
                  {item}{" "}
                  {props.tick?.some(
                    (animation) =>
                      animation !== undefined &&
                      animation.animationType === item
                  ) ? (
                    <CheckIcon style={{ color: "#00b10a", fontSize: 15 }} />
                  ) : (
                    ""
                  )}
                  {/*   </div> */}
                </MenuItem>
              );
            })}
        </Select>
      )}
    </FormControl>
  );
};

export default DropdownWithLabelTemplate;
